<template>
	<td title="Contrato suspenso" v-if="statusContrato == 'suspenso'">
		<i class="fa fa-close"></i>
	</td>
	<td
		title="Iniciar tarefa"
		@click="toggleStatus(1)"
		v-else-if="statusContrato != 'suspenso' && status == 0"
	>
		<i class="fa fa-play"></i>
	</td>
	<td
		title="Finalizar tarefa"
		@click="toggleStatus(2)"
		v-else-if="statusContrato != 'suspenso' && status == 1"
	>
		<i class="fa fa-stop"></i>
	</td>
	<td
		title="Tarefa Finalizada"
		v-else-if="statusContrato != 'suspenso' && status == 2"
	>
		<i class="fa fa-check"></i>
	</td>
</template>
<script>
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		props: ['cod', 'status', 'statusContrato', 'codContrato'],
		inject: ['update'],
		methods: {
			toggleStatus(status) {
				//1531
				let sData = {
					status: status,
					cod: this.cod,
					cod_contrato: this.codContrato,
				};
				WBS.send('private-custom-toggleStatusOS', sData, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Status alterado com sucesso!');
						this.update();
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>
<style scoped>
	td {
		cursor: pointer;
	}
	.fa-play {
		color: #6b6b6b;
	}
	.fa-stop {
		color: #3c8dbc;
	}
	.fa-check {
		color: #40af12;
	}
	.fa-close {
		color: #fc561c;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeAgroup/components/botao-status-os.vue